var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 36,
    viewBox: "0 0 31 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6065 35.6414C14.7169 35.7577 14.851 35.8496 14.9999 35.9111C15.1488 35.9727 15.3092 36.0025 15.4706 35.9986C15.6325 36.0069 15.7942 35.9791 15.9438 35.9173C16.0934 35.8554 16.227 35.7612 16.3346 35.6414L26.0638 25.8272C28.9001 22.9762 30.4925 19.1423 30.4997 15.1466C30.507 11.151 28.9286 7.31138 26.1027 4.45038C24.7578 3.07434 23.1514 1.97328 21.3753 1.21008C19.5991 0.446871 17.6881 0.0364766 15.7513 0.00232297C13.8145 -0.0318306 11.8898 0.310919 10.0872 1.01102C8.28463 1.71112 6.63947 2.75484 5.24558 4.08259C5.13757 4.18919 5.02093 4.2958 4.91076 4.41093C2.0889 7.2773 0.507037 11.1146 0.499781 15.1113C0.492525 19.108 2.06044 22.9509 4.87186 25.8272L14.6065 35.6414Z",
    fill: "#6BB22F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25458 17.731C9.61322 18.0897 10.1947 18.0897 10.5533 17.731L15.4142 12.8702L20.275 17.731C20.6336 18.0897 21.2151 18.0897 21.5738 17.731C21.9324 17.3724 21.9324 16.7909 21.5738 16.4322L16.0636 10.922C15.7049 10.5634 15.1234 10.5634 14.7648 10.922L9.25458 16.4322C8.89593 16.7909 8.89593 17.3724 9.25458 17.731Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerGreen);
export default __webpack_public_path__ + "static/media/marker-green.d1fa00f3851536458fc9416a8efce40c.svg";
export { ForwardRef as ReactComponent };